// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgFatCrossIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M18.5 20c-.38 0-.77-.15-1.06-.44L12 14.12l-5.44 5.44c-.59.59-1.53.59-2.12 0a1.49 1.49 0 0 1 0-2.12L9.88 12 4.44 6.56a1.49 1.49 0 0 1 0-2.12 1.5 1.5 0 0 1 2.12 0L12 9.88l5.44-5.44a1.49 1.49 0 0 1 2.12 0c.59.59.59 1.53 0 2.12L14.12 12l5.44 5.44c.59.59.59 1.53 0 2.12-.29.29-.68.44-1.06.44" />
  </g>
);
export default SvgFatCrossIcon;
SvgFatCrossIcon.displayName = 'SvgFatCrossIcon';
